export const CUSTOMER_CONTACT_EMAIL = "contact@worthyidea.net";
export const CUSTOMER_CONTACT_MAILTO = `mailto:${CUSTOMER_CONTACT_EMAIL}`;
export const STAGING_PILOT_MAILTO = `mailto:${CUSTOMER_CONTACT_EMAIL}?subject=${encodeURIComponent("WorthyIdea staging pilot")}`;
